import { useEffect } from "react";

const getDefaultTitle = () => {
  if (process.env.REACT_APP_BUILD_TARGET === "advisor") {
    return "Advisor";
  }
  return "Member";
};

export default (title: string | null | undefined) => {
  useEffect(() => {
    let setTimer: ReturnType<typeof setTimeout>;
    const defaultTitle = getDefaultTitle();
    const titleToSet = title || defaultTitle;

    setTimer = setTimeout(() => {
      document.title = titleToSet;
    }, 50);

    return () => {
      clearTimeout(setTimer);
      // This is a hack and potential small memory leak, but it prevents
      // the title from flashing when the page is navigated away from.
      setTimeout(() => {
        if (document.title === titleToSet) {
          document.title = defaultTitle;
        }
      }, 100);
    };
  }, [title]);
};
